module.exports = __webpack_public_path__ + "media/images/client-logos/client-logo_lv-daf04ca5fd9eb29b95efcef2c8dbec77.png";